module.exports = __webpack_public_path__ + "c4704db8ef40eba25d94efb1770084ba.svg";